import { actions, Control } from 'react-redux-form'
import { useDispatch } from 'react-redux'

import CustomSelect from '../../components/select/CustomSelect'

const CustomSelectControl = props => {
  const { model, ...rest } = props
  const dispatch = useDispatch()
  const clearSelection = () => dispatch(actions.change(props.model, null))
  const changeModelValue = selection => dispatch(actions.change(props.model, selection))

  return (
    <Control.custom
      model={model}
      component={CustomSelect}
      mapProps={{
        initialSelectedItem: selectedProps => {
          //console.log("Initial selection", props.viewValue)
          return selectedProps.modelValue
        },
        onChange: selectedProps => {
          return item => {
            return selectedProps.changeModelValue?.(item)
          }
        }
      }}
      clearSelection={clearSelection}
      changeModelValue={changeModelValue}
      {...rest}
    />
  )
}

export default CustomSelectControl
